import type { ReasoningStepData } from './ReasoningStepsList';
import { resolveStepTitle } from './stepTitle';

/**
 * The one-line title of the most recent reasoning step — what the "Thinking…"
 * loader label shows once steps stream in — or null before any non-final step
 * has arrived. The final step is the answer, not reasoning, so it is never the
 * latest step.
 */
export function resolveLatestStepTitle(
  steps: ReasoningStepData[]
): string | null {
  for (let i = steps.length - 1; i >= 0; i--) {
    if (!steps[i].is_final) {
      return resolveStepTitle(steps[i]);
    }
  }
  return null;
}
